import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';
import React from 'react';

import { Output } from '../common/SingleInput';

const DriveSummarySingle = ({ drives }) => {
    if (!drives) {
        return;
    }
    const drive = drives[0];
    if (!drive) {
        return;
    }

    return (
        <Wrapper>
            <Title>
                <h3>Drive Summary</h3>
            </Title>
            <Content>
                <Output
                    label="Drive Description"
                    variable="-"
                    unit="-"
                    variableName="description"
                    value={drive.description}
                />
                <Output
                    label="Power(Tension) Distribution"
                    variable="-"
                    unit="-"
                    variableName="distribution"
                    value={drive.distribution}
                />
                <Output
                    label="Actual Power"
                    variable="Pa"
                    variableName="actualPower"
                    unit="kW"
                    value={drive.actualPower?.load}
                />
                <Output
                    label="Mechanical Efficiency"
                    variable="etha"
                    unit="-"
                    variableName="mechanicalEfficiency"
                    value={drive.mechanicalEfficiency}
                />
                <Output
                    label="Motor Power Required"
                    variable="PM"
                    variableName="requiredPower"
                    unit="kW"
                    value={drive.requiredPower}
                />
                <Output
                    label="Motor Selected"
                    variable="-"
                    variableName="selectedMotor"
                    unit="kW"
                    value={drive.selectedMotor}
                />
                <Output
                    label="Effective Tension"
                    variable="-"
                    unit="-"
                    variableName="effectiveTension"
                    value={drive.effectiveTension?.load}
                />
                <Output label="Wrap Angle" variable="-" unit="-" variableName="wrapAngle" value={drive.wrapAngle} />
                <Output
                    label="Firction Coefficient between Pulley Lagging and Belt"
                    variable="-"
                    unit="-"
                    variableName="frictionCoeff"
                    value={drive.frictionCoeff}
                />
                <Output
                    label="Driving Factor"
                    variable="-"
                    unit="-"
                    variableName="drivingFactor"
                    value={drive.drivingFactor}
                />
                <Output
                    label="Minimum Slackside Tension to Transmit Effective Tension"
                    variable="F2"
                    unit="N"
                    variableName="requiredSlackSideTension"
                    value={drive.requiredSlackSideTension?.load}
                />
                <Output
                    label="Permissible Slack Rate between the Idlers(0.05 ~ 0.02)"
                    variable="h/a"
                    variableName="permissibleSagRatio"
                    unit="-"
                    value={drive.permissibleSagRatio}
                />
                <Output
                    label="Minimum Belt Tension Required"
                    variable="Fmin"
                    variableName="minSagTension"
                    unit="N"
                    value={drive.minSagTension?.load}
                />
                <Output
                    isSub
                    label="Carry"
                    variable="FminCarry"
                    variableName="minCarry"
                    unit="N"
                    value={drive.minCarry?.load}
                />
                <Output
                    isSub
                    label="Return"
                    variable="FminReturn"
                    variableName="minReturn"
                    unit="N"
                    value={drive.minReturn?.load}
                />
                <Output
                    label="Return-side Belt Tension (at Head due to Slope)"
                    variable="F3"
                    variableName="slopeTensionReturn"
                    unit="N"
                    value={drive.slopeTensionReturn?.load}
                />
                <Output
                    label="Max. Tension"
                    variable="Fmax"
                    variableName="maxTension"
                    unit="N"
                    value={drive.maxTension}
                />
                <Output
                    label="Fmax = FU + F2"
                    variable=""
                    variableName="maxTension1"
                    unit="N"
                    value={drive.maxTension1}
                    isSub
                />
                <Output
                    label="Fmax = FU + Fmin"
                    variable=""
                    variableName="maxTension2"
                    unit="N"
                    value={drive.maxTension2}
                    isSub
                />
                <Output
                    label="Fmax = FU + Fmin + F3"
                    variable=""
                    variableName="maxTension3"
                    unit="N"
                    value={drive.maxTension3}
                    isSub
                />
                <Output
                    label="Tight Side Tension"
                    variable="T1"
                    unit="N"
                    variableName="tightSideTension"
                    value={drive.tightSideTension?.load}
                />
                <Output
                    label="Slack Side Tension"
                    variable="T2"
                    unit="N"
                    variableName="slackSideTension"
                    value={drive.slackSideTension?.load}
                />
            </Content>
        </Wrapper>
    );
};

export default DriveSummarySingle;


/* =================   Styles   ================== */
const Wrapper = styled.div``;
const Title = styled.div``;
const Content = styled.div``;
